export default [
  {
    name: 'Server',
    body:
      '사용 편의성을 위해 국내와 동일한 구성으로 서비스를 제공합니다. Standard 및 High Memory의 다양한 타입의 서버와 최소 10 GB에서 최대 2,000 GB의 추가 Storage를 사용할 수 있습니다. Linux 및 Windows 그리고 MSSQL 등의 다양한 운영체제 및 버전을 확인할 수 있습니다. 이와 함께 국내에서 이용할 수 있는 Monitoring, Load Balancer, 공인 IP, 스냅샷 등 다양한 연동 서비스도 이용할 수 있습니다. 또한, 인프라 환경 리빌딩을 완료한 리전에서는 SSD Server, VDS(Virtual Dedicated Server), Autoscaling, Object Storage, NAS, IPSec VPN 등 다양한 Server 상품들을 추가적으로 이용할 수 있습니다.',
    subText: '2020년 기준 리빌딩 완료 리전 : 싱가포르, 일본, 미국(서부), 독일',
  },
  {
    name: 'Copy of Server <i>Image and Snapshot</i>',
    body:
      '한 리전에서 생성한 서버 이미지와 스냅샷을 다른 리전으로 이전, 복제하여 신규 리전에서 같은 서버를 생성하거나, 생성돼 있는 서버에 스냅샷을 사용해 Storage를 추가할 수 있습니다. 서버 이미지와 스냅샷의 리전 간 이전은 글로벌 전용회선을 통해 무료로 이용할 수 있습니다. 복제가 완료된 후에는 이전된 리전에서 Storage 비용이 발생합니다. 리전 간 이전, 복제는 동일 리전 내에서보다 상대적으로 많은 시간이 소요됩니다.',
  },
  {
    name: 'Load Balancer',
    body:
      '서버의 성능과 부하를 고려해 네트워크 트래픽을 다수의 서버로 분산시키는 Load Balancer가 리전 별로 제공됩니다. 리전 별로 외부와 통하는 네트워크 트래픽을 공인 IP 기반의 Load Balancer로 관리할 수 있고, 사설 Load Balancer를 제공해 사설 IP로 구성된 리전 내 내부망의 서버 부하를 분산할 수도 있습니다. 공인 및 사설 Load Balancer는 생성한 Load Balancer 수에 따라 시간 요금이 청구되며, 다른 리전에 있는 사설 Load Balancer와 통하는 경우 글로벌 전용회선 이용 요금이 부과됩니다.',
  },
  {
    name: 'Object Storage',
    body:
      'Object Storage는 공인 IP 및 API를 사용하여 데이터를 안전하게 보관할 수 있습니다. 특히, Amazon S3와 호환되는 API를 지원함으로써 Amazon S3 상품을 기준으로 만들어진 응용 프로그램을 그대로 사용할 수 있습니다. 리전 단위 서비스인 Object Storage는, 리전 별로 생성된 데이터를 보관하는 것이 효율적이며, 리전 간 데이터를 이전하는 것은 가능하지만 인터넷 회선의 지연 속도(Latency)에 따라 전송 오류 등이 발생할 가능성이 높고 고객의 서비스 품질에 영향을 줄 수 있습니다.',
    subText: '2020년 기준 리빌딩 완료 리전 : 싱가포르, 일본, 미국(서부), 독일 리전',
  },
  {
    mark: 'kr',
    name: 'Global leased-line',
    body:
      '글로벌 리전에서 서비스되고 있는 Server, Load Balancer 등은 인터넷 회선 기반의 공인 IP 통신은 물론, 글로벌 전용회선 기반의 사설 IP 통신도 가능합니다. 여러 리전을 통합 환경으로 구축하는 경우, 사설 IP 통신을 주 회선으로, 공인 IP 통신을 부회선으로 구성하면 서비스 가용성을 보다 강화할 수 있습니다. 안정적인 네트워크 품질을 핵심으로, 고객에게 비용 절감 효과를 가져옵니다.',
  },
  {
    name: 'Private Subnet Peering',
    body:
      '네이버 클라우드 플랫폼의 글로벌 네트워크를 이용하는 동시에 다른 리전에 있는 Private Subnet과 Peering의 연결을 통한 안정적인 통신이 가능합니다. 인터넷 구간에서 발생할 수 있는 보안 취약을 개선하고, 네트워크 품질을 안정적으로 유지합니다.',
  },
  {
    mark: 'kr',
    name: 'Anti-DDoS/IDS Security',
    body:
      '네이버와 LINE 글로벌 서비스 운영을 통해 확인된 보안 역량은 네이버 클라우드 플랫폼의 가장 큰 강점입니다. 각 리전마다 다양한 보안 솔루션 및 인프라 장비가 구축돼 있으며, 다년간 축적한 보안 운영 노하우와 역량을 바탕으로 고객의 데이터를 안전하게 보호합니다.',
    bodyBottom:
      'Anti-DDos는 Security Monitoring Managed 서비스에서 제공받을 수 있습니다. Security Monitoring 서비스는 한국, 싱가폴, 일본, 미국(서부), 독일 리전에서 가능하며, 추후 모든 리전에서 제공될 예정입니다.',
  },
];
